module.exports = __webpack_public_path__ + "img/selfbank.59356311.png";